import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';
import * as Animate from '../animate'

Alpine.store('sidebar', {
    open: localStorage.isSidebarOpen == 'true',

    toggle() {
        localStorage.isSidebarOpen = !this.open;
        this.open = !this.open;

        window.dispatchEvent(new CustomEvent('close-submenus'));

        if (this.open && Alpine.store('quickView').open && window.innerWidth < 1680) {
            Alpine.store('quickView').toggle();
        }
    },
});

Alpine.store('quickView', {
    open: localStorage.quickView == 'true',

    toggle() {
        localStorage.quickView = !this.open;
        this.open = !this.open;

        if (this.open && Alpine.store('sidebar').open && window.innerWidth < 1680) {
            Alpine.store('sidebar').toggle();
        }
    },
});

Alpine.store('headerTableActions', {
    filter: false,
    sort: false,
    save: false,
    saved: false,
    actionButtons: false,

    toggleSave() {
        this.save = !this.save;
    },

    toggle(type) {
        const typeValue = this[type];

        this.filter = false;
        this.sort = false;
        this.saved = false;

        this[type] = !typeValue;

    },

    closeAll() {
        this.filter = false;
        this.sort = false;
        this.saved = false;
    },
});

Alpine.store('editMode', {
    contentId: null,
    enable: true,
    ref: null,
    classesToIgnore: ['flatpickr-calendar', 'confirmation-modal', 'phpdebugbar'],
    idsToIgnore: ['livewire-error', 'Measuremate'],
    init() {
        window.addEventListener('editMode::reset', () => this.reset())
        window.addEventListener('editMode::edit', ({ detail }) => {
            const { id, ref = null, retry = false } = detail
            this.edit(id, ref, retry)
        })
    },
    edit(contentId, ref = null, retry = false) {
        this.ref = ref
        const self = this
        if (!self.enable) {
            return;
        }

        document.addEventListener('DOMContentLoaded', () => {
            window.livewire.hook('message.sent', (component) => {
                const method = component.updateQueue[0].payload.method
                const params = component.updateQueue[0].payload.params

                const enableMethods = [
                    '$set',
                    '$toggle',
                    'cancel'
                ]

                if (typeof params !== "undefined" && enableMethods.includes(method)) {
                    if (method === 'cancel' || method === 'close') {
                        self.enable = true;
                        return;
                    }
                    if (params[0] === 'show' || params[0] === 'open') {
                        if (typeof params[1] === "undefined") {
                            self.enable = false;
                            return;
                        }
                        if (params[1]) {
                            self.enable = false;
                            return;
                        }
                        self.enable = true;
                    }
                }
            })
        });

        let content = document.getElementById(contentId);

        if (typeof content === 'undefined' || content === null && retry) {
            setTimeout(() => this.edit(contentId, ref, true), 100)
            return;
        }

        this.contentId = contentId;

        if (content) {
            content.focus();
        }

        window.onbeforeunload = () => { return true }

        if (ref) {
            var refElement = document.querySelector('[x-ref=' + ref + ']');

            if (refElement) {
                refElement.scrollTo({ 'left': 0 })
                document.getElementById(contentId).parentNode.setAttribute('style', 'width:' + refElement.offsetWidth + 'px !important');
            } else {
                console.error('Missing ref element for editMode: ' + ref);
            }
        }

        window.addEventListener('click', this.disableClicks.bind(this), true)
    },
    disableClicks(event) {
        if (!this.contentId) return;

        const el = document.getElementById(this.contentId)
        const modalContent = document.getElementById('modalView')
        const interactiveModalRoot = event?.target?.closest?.('[data-modal-root]')

        if (el && el.contains(event?.target) || modalContent?.contains(event?.target) || interactiveModalRoot || this.checkIfIgnored(event.target)) return;

        const isModal = el.getAttribute('aria-modal')

        event.stopImmediatePropagation()
        event.preventDefault()

        Animate.animation(el, isModal)
    },
    checkIfIgnored(target) {
        let elementIgnore = false;

        Array.from(this.classesToIgnore).forEach(className => {
            const elements = document.getElementsByClassName(className)

            Array.from(elements).map(el => {
                if (el.contains(target)) {
                    elementIgnore = true;
                }
            })
        })

        Array.from(this.idsToIgnore).forEach(id => {
            const elements = document.querySelectorAll('#' + id)

            Array.from(elements).map(el => {
                if (el.contains(target)) {
                    elementIgnore = true;
                }
            })
        })

        return elementIgnore;
    },
    reset() {
        this.contentId = null;

        window.onbeforeunload = () => { }

        window.removeEventListener('click', this.disableClicks.bind(this), true)

        window.dispatchEvent(new CustomEvent('cancel'))

        if (document.querySelector('[x-ref=' + this.ref + ']') != null) {
            document.querySelector('[x-ref=' + this.ref + ']').removeAttribute('style')
        }
    },
    isOn($contentId = null) {
        return this.contentId === $contentId && $contentId !== null
    }
});

Alpine.store('modalView', {
    isOpen: false,

    open() {
        this.isOpen = true;
    },

    close() {
        this.isOpen = false;
    },
});

Alpine.store('modal', {
    isOpen: false,
    maxWidth: '2xl',
    centered: true,
    withOpacity: true,
    withTransition: true,
    sizeIs($size) {
        return this.maxWidth === $size;
    }
});

Alpine.store('specifications', {
    openParameters: localStorage.specificationsOpenParameters == 'true',

    setOpenParameters(value) {
        this.openParameters = value;

        localStorage.specificationsOpenParameters = value;
    },
});

Alpine.store('specificationsOptions', {
    expanded: [],
    addExpanded(optionId) {
        this.expanded.push(optionId)
    },
    removeExpanded(optionId) {
        this.expanded = this.expanded.filter((item) => item !== optionId)
    },
    isExpanded(optionId) {
        return this.expanded.includes(optionId)
    }
});

const getAiAgentOpenState = () => {
    try {
        return window.localStorage.getItem('aiAgentOpen') === 'true';
    } catch (error) {
        return false;
    }
};

const setAiAgentOpenState = (isOpen) => {
    try {
        window.localStorage.setItem('aiAgentOpen', isOpen ? 'true' : 'false');
    } catch (error) {
        // No-op if storage is unavailable (private mode, blocked storage, etc).
    }
};

Alpine.store('aiAgent', {
    open: getAiAgentOpenState(),

    toggle() {
        this.open = !this.open;
        setAiAgentOpenState(this.open);
    },

    close() {
        this.open = false;
        setAiAgentOpenState(this.open);
    },
});
